// extracted by mini-css-extract-plugin
export default {"signingControl":"signing-control_signingControl__vI-5T","signingControl__tabs":"signing-control_signingControl__tabs__THs0F"};